<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <input v-model="filterKey" placeholder="Search..." class="form-control">
      </div>
      <div class="col-sm-6">
        <button class="btn btn-default" @click="clearSearch">Limpiar</button>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-bordered table-condensed">
          <thead>
          <tr>
            <th>RUN</th>
            <th>Nombre</th>
            <th>País</th>
            <th>Handicap</th>
            <th>Categoría</th>
            <th>Cancha</th>
            <th>Estado</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="registration in registrations | filterBy filterKey | orderBy 'player.surname'">
            <td>{{ registration.player.idc }}</td>
            <td>
              {{registration.player.surname}} {{registration.player.mothers_surname}} {{ registration.player.name}} {{registration.player.middle_name}}
            </td>
            <td>
              <span class="flag-icon flag-icon-{{registration.player.country.code | lowercase}}"></span>
            </td>
            <td>{{ registration.handicap }}</td>
            <td>{{ registration.category.name }}</td>
            <td>{{ registration.course.name }}</td>
            <td>{{ registration.status }}</td>
            <td>
              <button type="button" @click="selectPlayer(registration)" class="btn btn-primary">
                <span class="glyphicon glyphicon-edit"></span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal :show.sync="show_registration" large="true" effect="fade" backdrop="false">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Tarjeta de jugador</h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <registration :championship="id" :player="player"></registration>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click='closeRegistration'>Cerrar</button>
      </div>
    </modal>

    <modal :show.sync="show_registration_edit" large="true" effect="fade" backdrop="false">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">Registro de jugador</h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <registration-edit  :registration="registration"></registration-edit>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click='closeRegistrationEdit'>Cerrar</button>
        <button type="button" class="btn btn-primary" @click='saveRegistrationEdit'>Guardar</button>
      </div>
    </modal>
  </div>
</template>

<style>

</style>
<script>
  import configure from '../../configure'
  import * as actions from '../../vuex/actions'
  import {
    getCurrentPlayer,
    getCurrentDate,
    getConfigRegistrations
  } from '../../vuex/getters'
  import Registration from '../../components/configuration/Registration.vue'
  import RegistrationEdit from '../../components/configuration/RegistrationEdit.vue'
  import {modal} from 'vue-strap'

  export default{
    components: {Registration, modal, RegistrationEdit},
    vuex: {
      getters: {
        registrations: getConfigRegistrations
      },
      actions: actions
    },
    data() {
      return {
        filterKey: '',
        show_registration: false,
        show_registration_edit: false,
        registration: false,
        last_registration: false
      }
    },
    methods: {
      selectPlayer(player) {
        this.registration = player
        this.last_registration = player
        this.filterKey = ''
        this.show_registration_edit = true
      },
      clearSearch() {
        this.filterKey = ''
      },
      closeRegistration() {
        this.show_registration = false
      },
      closeRegistrationEdit() {
        this.show_registration_edit = false
        this.registration = this.last_registration
      },
      saveRegistrationEdit() {
        this.$progress.start()
        this.$log('registration')
        this.$http.put(
          configure.api_url + 'registrations/' + this.registration.id,
          this.registration
        ).then(response => {
          this.updatePlayer()
        }, error => {
          this.$progress.failed()
        })
        this.show_registration_edit = false
      },
      updatePlayer() {
        this.$http.put(
          configure.api_url + 'players/' + this.registration.player.id,
          this.registration.player
        ). then(response => {
          this.$progress.finish()
        }, error => {
          this.$progress.failed()
        })
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** PlayerSearch.vue?372c59e7
 **/